<template>
    <div>
        <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered custom" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">{{ $t('modal_title') }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                {{ $t('unsub_confirmation') }}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $t('no') }}</button>
                <a type="button" @click="logout_cm(is_unsub_cm)" style="text-decoration:none; color: white; text-align:center" class="btn  btn-danger">{{ $t('yes') }}</a>
            </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: mapGetters([
    "langButton_cm",
    "lang_cm",
    "auth_cm",
    "country_cm",
    "is_unsub_cm"
  ]),
  methods: {
    ...mapActions([
      "fetchLocale_cm",
      "fetchTranslateButton_cm",
      "logout_cm"
    ])
  }
};
</script>
<style scoped lang="scss">
.custom {
  .modal-title {
    font-size: 1.4rem;
    font-weight: 600;
  }
  .modal-body {
    color: black;
    font-size: 1.2rem;
  }
}
.ar_layout {
  .custom .close {
    margin: -1rem auto -1rem -1rem;
    float: left;
  }
  .modal-body {
    color: black;
    text-align: right;
  }
  .modal-footer .btn {
    margin-left: 0.25rem;
  }
  .modal-title {
    font-size: 1.6rem;
  }
  .modal-body {
    font-size: 1.4rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cutemobi/UnsubModal.vue